module.exports = __webpack_public_path__ + "media/img/pages/companies/j-w-fr-b0e75ae6d9c8297c424336906f73d4e4.png";